import React, { useEffect, useState } from "react";
import {  Col, Container, Row, Button } from "react-bootstrap";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ReactTost from "../../ReactTost";
import Loader from "../../Loader";
import UserBotDelete from '../Modal/UserBotDelete';
import BtnLoader from "../../BtnLoader";
import { useTranslation } from "react-i18next";
import UserBotsNew from "./UserBotsNew";

const UserChatBotSetting = (props) => {
  const [temperature, setTemperature] = useState(0);
 
  const [botId, setBotId] = useState(0);
  const [name, setName] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const [promptBtn, setPromptBtn] = useState(false);
  const [prompt, setPrompt] = useState("");
  const [model, setModel] = useState("");
  const [domain, setDomain] = useState("");
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [visibility, setVisibility] = useState("");
  // const [messageCount, setMessageCount] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [setLoading, setIsLoading] = useState(false);
  const [messageLimit, setMessageLimit] = useState();
  const [updateId, setUpdateId] = useState(0);
  const [limit, setLimit] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [errorDisplay, setErrorDisplay] = useState("");
  const [deleteBotId, setDeleteBotId] = useState();
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [getBots, setGetBots] = useState(true);
  const user = localStorage.getItem("id");
  const {t} = useTranslation();
  const {id} = useParams();
  const navigate=useNavigate();
  
  const handleTemperatureChange = (event) => {
    const newValue = parseFloat(event.target.value);
    setTemperature(newValue);
  };
  
  const handleResetBasePrompt = () => {
    setPrompt(
      t("Act as an intelligent AI Assistant who will furnish me with detailed answers based on the provided information. If the answer is not available, respond with 'Hmm, I am not sure.' Never break character.")
    );
  };
  
  const handlePrompt = () =>{
    setPromptBtn(false);
    setPrompt("");
  }

  const handleDeleteSuccess = () =>{
    if (getBots) {
      setGetBots(false);
      axios.get(`${API_URL}/${API_VERSION}/bot/user/${user}`,{
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }).then((response)=>{
        if(response.data.length!==0){
          let getBotId = response.data[response.data.length - 1].id;
          setGetBots(false);
          navigate(`/my-bots/${getBotId}`)
        }
        else{
          navigate('/my-bots');
        }
      
      }).catch((err)=>{
        console.log(err)
      })
    }
  }
 
  
  function updateBot(e) {
    e.preventDefault();
    setIsLoading(true);
    axios
      .patch(
        `${API_URL}/${API_VERSION}/bot/${id}`,
        {
          name,
          settings: {
            prompt,
            model,
            temperature,
            visibility,
            domain,
            // messageCount,
            messageLimit,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        setIsLoading(false);
        setType("Success");
        setMessage(t("Setting updated successfully"));
        showAlert(true);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }
  
  useEffect(() => {

        axios
        .get(`${API_URL}/${API_VERSION}/bot/${id}`, {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          if (response.data) {
           setBotId(response.data.id);
            setName(response.data.name);
          }
          if (response.data.settings) {
            setTemperature(response.data.settings.temperature);
            setVisibility(response.data.settings.visibility);
            setModel(response.data.settings.model);
            setDomain(response.data.settings.domain);
            // setMessageCount(response.data.settings.messageCount);
            setMessageLimit(response.data.settings.messageLimit);
          }
          if (response.data.settings.prompt === undefined || response.data.settings.prompt === "" || response.data.settings.prompt === null) {
            setPromptBtn(true);
          }else{
            setPromptBtn(false);
            setPrompt(response.data.settings.prompt);
          }
          
        })
        .catch((error) => {
          console.log(error);
        });
    
    
  }, [API_URL, API_VERSION, id]);

  return (
    <>
      <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />
      {setLoading ? ( <Loader /> ) : ( 
        <section className="usersettings">
          <Container>
            <Row className="justify-content-center">
              <Col md={12} className="mb-4">
                <div className="settings_wrap">
                  <form action="">
                    <div className="form-group">
                      <label className="form-label">
                        {t("Name")}
                        <OverlayTrigger
                          key="right"
                          placement="right"
                          overlay={<Tooltip>{t("name info")}</Tooltip>}
                        >
                          <span className="ms-2 text-orange">
                            <i className="fa-solid fa-circle-question"></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <input
                        className="form-control bot_name"
                        type="text"
                        name="name"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      {promptBtn ?(<button className="userbutton base_promt_btn" onClick={handlePrompt}>Add Base Prompt</button> ): 
                      (<div>
                        <div className="flex-column flex-sm-row d-flex align-items-sm-start align-items-md-center  align-items-lg-center justify-content-between mb-2">
                          <label className="form-label mb-0">
                            {t("Base Prompt (system message)")}
                            <OverlayTrigger
                              key="right"
                              placement="right"
                              overlay={<Tooltip>{t("Base Prompt info")}</Tooltip>}
                            >
                              <span className="ms-2 text-orange">
                                <i className="fa-solid fa-circle-question"></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                        </div>
                        <textarea
                          rows="3"
                          id="exampleForm.ControlTextarea1"
                          className="form-control"
                          spellcheck="false"
                          value={prompt}
                          onChange={(event) => setPrompt(event.target.value)}
                        ></textarea>
                      </div>
                      )}
                    </div>
                   
                    <div className="form-group">
                      <label className="form-label">
                        {t("Temperature")}
                        <OverlayTrigger
                          key="right"
                          placement="right"
                          overlay={<Tooltip>{t("Temperature info")}</Tooltip>}
                        >
                          <span className="ms-2 text-orange">
                            <i className="fa-solid fa-circle-question"></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <strong style={{ float: "right" }}>{temperature}</strong>
                      <input
                        type="range"
                        className="form-range"
                        min="0"
                        max="1"
                        step="0.1"
                        id="customRange"
                        value={temperature}
                        onChange={(e) => handleTemperatureChange(e)}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        {t("Visibility")}
                        <OverlayTrigger
                          key="right"
                          placement="right"
                          overlay={<Tooltip>{t("Visibility info")}</Tooltip>}
                        >
                          <span className="ms-2 text-orange">
                            <i className="fa-solid fa-circle-question"></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        value={visibility}
                        onChange={(event) => setVisibility(event.target.value)}
                      >
                        <option  value="public">{t("public")}</option>
                        <option value="private">{t("private")}</option>
                      </select>
                    </div>
                    {visibility && visibility === "private" && (
                      <div className="form-group">
                        <label className="form-label">
                          {t("Domains")}
                          <OverlayTrigger
                            key="right"
                            placement="right"
                            overlay={<Tooltip>{t("Domains info")}</Tooltip>}
                          >
                            <span className="ms-2 text-orange">
                              <i className="fa-solid fa-circle-question"></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <textarea
                          rows="3"
                          id="exampleForm.ControlTextarea1"
                          className="form-control"
                          spellCheck="false"
                          value={domain}
                          onChange={(event) => setDomain(event.target.value)}
                        ></textarea>
                      </div>
                    )}
                    
                    <div className="btn_group">
                      <button
                        type="button"
                        className="userbutton"
                        value="SUBMIT"
                        onClick={(e) => updateBot(e)}
                        disabled={setLoading}
                        >
                          {setLoading ? <BtnLoader /> : 'Submit'}
                      </button>
                      <Button
                        variant=""
                        onClick={() => {
                          setDeleteBotId(botId);
                          setDeleteModalShow(true);
                        }}
                      >
                      {t("Delete")} <i className="fa-solid fa-trash-can"></i>
                    </Button>
                  </div>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    )}

    {deleteModalShow && 
      <UserBotDelete
        show={deleteModalShow}
        deleteBotId={deleteBotId}
        onDeleteSuccess={handleDeleteSuccess}
        onHide={() => {
          setDeleteModalShow(false);
          setGetBots(true)
        }}
      />
    }
    </>
  );
};

export default UserChatBotSetting;
